// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"Container_skillContainer__1E50Z","heading":"Container_heading__19QNu","years":"Container_years__2lOnW"};